import React from 'react';
import {useRoutes} from 'react-router-dom';
import './App.scss';
import {
  AccountContextProvider,
  AccountRegistrationProvider,
  AuthProvider,
  EmployerCandidateProvider,
  JobTitleProvider,
  OpportunityProvider,
  OrganizationProvider,
  SkillProvider,
} from './contexts';
import {routes} from './routes';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App: React.FC = () => {
  const element = useRoutes(routes);

  return (
    <AuthProvider>
      <AccountContextProvider>
        <OrganizationProvider>
          <AccountRegistrationProvider>
            <JobTitleProvider>
              <SkillProvider>
                <OpportunityProvider>
                  <EmployerCandidateProvider>
                    <div className="App">{element}</div>
                    <ToastContainer
                      position="top-center"
                      autoClose={3000}
                      hideProgressBar={true}
                      newestOnTop={true}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      theme="light"
                    />
                  </EmployerCandidateProvider>
                </OpportunityProvider>
              </SkillProvider>
            </JobTitleProvider>
          </AccountRegistrationProvider>
        </OrganizationProvider>
      </AccountContextProvider>
    </AuthProvider>
  );
};
export default App;
